import { createPortal } from 'react-dom';
import { THEME_OPTIONS } from 'components/SiteTheme';
import './SiteThemeControl.css';

export default function SiteThemeControl({ preference, select }) {
  return createPortal(<div className="site-theme-control" role="group" aria-label="Color theme">
    {THEME_OPTIONS.map(value => <button key={value} type="button" aria-pressed={preference === value} onClick={() => select(value)}>{value[0].toUpperCase() + value.slice(1)}</button>)}
  </div>, document.body);
}
